import React from "react"
import { Layout } from "antd"
import { Outlet } from "react-router-dom"
import { NavigationPath } from "../ProHomeLayout/NavigationPath"
import { useDevice } from "hooks/useDevice"
import styles from "./Index.module.css"

export const ProMessagesLayout = () => {
  const { isMobile, isTablet } = useDevice()
  return (
    <Layout className={styles.layout}>
      {!isMobile && !isTablet && <NavigationPath className="pl-m pr-m " />}
      <Outlet />
    </Layout>
  )
}
